import { Component, OnInit } from '@angular/core';
import Feature from 'ol/Feature';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { FeatureType } from 'src/app/models/EnumTypes';
import { NavaidModel } from 'src/app/models/navaid';
import { ProcedureModel, ProcedureNavaidAssociationModel } from 'src/app/models/procedure';
import { NavaidsService } from 'src/app/services/navaids.service';
import { PointsService } from 'src/app/services/points.service';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import { TabsService } from 'src/app/services/tabsService';
import { ToolsControlService } from 'src/app/services/tools-control.service';

@Component({
  selector: 'app-procedure-navaid-association',
  templateUrl: './procedure-navaid-association.component.html',
  styleUrls: ['./procedure-navaid-association.component.scss'],
  standalone: false
})
export class ProcedureNavaidAssociationComponent implements OnInit {


  constructor(
    public procedureService : ProcedureControlService,
    private globalSelectionService : GlobalSelectionControlService,
    private toolsService : ToolsControlService,
    private navaidService : NavaidsService,
    public menuController : MenuManagementService,
    public tabsService: TabsService,

    public pointsService: PointsService) { }

  ngOnInit(): void {
  }

  cancel() : void{
    this.procedureService.closeProcedureNavaidAssociation();
  }

  save() : void{
    this.procedureService.procedureNavaidModel.rows.forEach(row => {
      let procedure : ProcedureModel = this.procedureService.procedureNavaidModel.procedures.find(el => el.name == row.Procedure);
      this.procedureService.procedureNavaidModel.columns.forEach(col => {
        let navaid : NavaidModel = null;
        const navaidInList : NavaidModel = this.procedureService.procedureNavaidModel.navaids.find(el => el.id == col.id);
        if (navaidInList != null){
          navaid = this.navaidService.getNavaidPayload(this.procedureService.procedureNavaidModel.navaids.find(el => el.id == col.id));
          navaid.critical = navaidInList.critical;
        }
        if(navaid != null && procedure.navaids.findIndex(el => el.id == navaid.id) > -1){
          procedure.navaids.splice(procedure.navaids.findIndex(el => el.id == navaid.id), 1);
        }
        if(navaid != null && typeof row[col.id] === "boolean" && row[col.id]){
          procedure.navaids.push(navaid);
        }
      });
      this.procedureService.saveProcedure(procedure);
      this.procedureService.closeProcedureNavaidAssociation();
      this.toolsService.navigationOnTop = false;
      this.globalSelectionService.clearAllSelected();
    });
    this.tabsService.closeTab();
  }
  pnaAddNavaids(){
   let navaidFeatures:Feature[] =  this.pointsService.getSelectedFeatures().filter(feat => feat.get('featureType') == FeatureType.Navaid)
   this.procedureService.pnaAddNavaids(navaidFeatures)
  }
  pnaAddProcedures(){
    let procedureFeatures:Feature[] =  this.pointsService.getSelectedFeatures().filter(feat => feat.get('featureType') == FeatureType.Procedure)
    this.procedureService.pnaAddProcedures(procedureFeatures);
  }

  pNASelectedCollumm(navaidId: string){
    for (const row of this.procedureService.procedureNavaidModel.rows){
      if (row[navaidId] == true){
        row["selected"] = true;
      } else {
        row["selected"] = false;
      }
    }
  }
}
